<div class="px-4 py-6 bg-on-primary rounded-xl">
    <app-main-title
        iconColor="text-custom-blue"
        iconSize="xl"
        titleSize="text-2xl"
        [icon]="['fas', ActionsEnum.LAYER]"
        [title]="'layer' | transloco: { COUNT: sourcesService.sources()!.length }" />
</div>

@if (sourcesService.sources()!.length) {
    <div class="flex justify-between w-full">
        <app-button
            [label]="(areLayersGrouped() ? 'ungroupLayers' : 'groupLayers') | transloco"
            [type]="ButtonType.NEUTRAL"
            (onClick)="updateLayerGrouped.emit(!areLayersGrouped())" />

        <app-button
            [label]="
                (mapLayerService.areLayersVisible() ? 'hideLayers' : 'showLayers')
                    | transloco: { COUNT: sourcesService.sources()!.length }
            "
            [tooltip]="
                mapEditModeService.activeEditLayerIds().size && mapEditModeService.isMapEditModeActive()
                    ? ('editViewLayerNotAffected' | transloco)
                    : undefined
            "
            [type]="ButtonType.NEUTRAL"
            (onClick)="handleLayersVisibility.emit(!mapLayerService.areLayersVisible())" />
    </div>
}

<div class="flex justify-end pr-2">
    <span class="text-custom-dark-grey text-body-2 justify-between"
        >{{ disabledSourcesCount() }} {{ 'disabledLayer' | transloco: { COUNT: disabledSourcesCount() } }}
        <fa-icon
            class="w-2 h-2 text-custom-extra-dark-grey"
            matTooltipClass="whitespace-pre-line"
            size="sm"
            [icon]="['fas', 'circle-info']"
            [matTooltip]="
                ['disabledLayer' | transloco | titlecase, 'disabledLayerZoomLevelInformation' | transloco].join('\n')
            " />
    </span>
</div>
